export default function ({ route, app }) {
    const zIndexClass = route.path.startsWith('/book/') ? 'z-index-10' : 'z-index-1';
    app.store.commit('setZIndexClass', zIndexClass);
}
